import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import ButtonGeneral from '../ButtonGeneral';

export type TToolTipProps = {
  name?: string;
  showHeader?: boolean;
  lines: string[];
  buttonText?: string;
  onPress: () => void;
  onClose?: () => void;
  icon?: React.ReactNode;
  position?: {
    top: number;
    left: number;
  };
  arrow?: React.ReactNode;
  arrowPosition?: {
    top: number;
    left: number;
  };
  footerText?: string;
};

export default function ToolTip({
  name = '',
  showHeader = true,
  lines,
  buttonText = 'Get started',
  onPress,
  onClose,
  icon,
  position,
  arrow,
  arrowPosition = { top: 0, left: 0 },
  footerText,
}: TToolTipProps) {
  return (
    <View style={{ position: 'relative' }}>
      <View style={[styles.container, position && { position: 'absolute' }, position]}>
        {/* Close Button */}
        {
          <TouchableOpacity style={styles.buttonX} onPress={onClose}>
            <Text style={styles.textX}>✕</Text>
          </TouchableOpacity>
        }

        {/* Icon aligned to top-left */}
        {icon && <View style={styles.iconContainer}>{icon}</View>}

        {/* Header */}
        {showHeader && <Text style={styles.header}>Welcome {name}!</Text>}

        {/* Text lines */}
        <View style={[styles.textContainer, footerText ? { marginBottom: 8 } : undefined]}>
          {lines.map((line, index) => (
            <Text key={index} style={styles.text}>
              {line}
            </Text>
          ))}
        </View>
        {footerText && <Text style={styles.footer}>{footerText}</Text>}

        {/* Button */}
        <ButtonGeneral onPress={onPress} title={buttonText} width={201} height={48} />
      </View>

      {arrow && position && (
        <View
          style={[
            {
              position: 'absolute',
              top: position.top + arrowPosition.top,
              left: position.left + arrowPosition.left,
            },
          ]}
        >
          {arrow}
        </View>
      )}
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    backgroundColor: '#FFF9E8',
    padding: 20,
    width: 252,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowRadius: 6,
    shadowOffset: { width: 0, height: 2 },
    position: 'relative',
    borderWidth: 2,
    borderBottomWidth: 5,
    borderColor: '#FFCF53',
    borderRadius: 16,
    // ❌ remove alignItems: 'center'
  },
  buttonX: {
    position: 'absolute',
    top: 8,
    right: 8,
    backgroundColor: '#FCEABB',
    width: 40,
    height: 40,
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 10,
  },
  textX: {
    color: '#000',
    fontSize: 20,
    fontWeight: 'bold',
  },
  iconContainer: {
    alignSelf: 'flex-start',
    marginBottom: 10,
  },
  header: {
    fontSize: 20,
    fontWeight: '700',
    color: '#E58B2E',
    marginBottom: 12,
    textAlign: 'left',
    alignSelf: 'stretch', // ✅ ensures full width for left alignment
  },
  textContainer: {
    marginBottom: 24,
    alignSelf: 'stretch', // ✅ ensures left alignment for text inside
  },
  text: {
    fontSize: 16,
    fontWeight: '600',
    textAlign: 'left',
    color: '#000',
    marginBottom: 4,
  },
  footer: {
    fontSize: 16,
    fontWeight: '600',
    textAlign: 'left',
    color: '#E58B2E',
    marginBottom: 24,
    alignSelf: 'stretch',
  },
  button: {
    backgroundColor: '#FFD65B',
    borderRadius: 12,
    paddingVertical: 10,
    paddingHorizontal: 30,
    alignSelf: 'center', // ✅ keeps button left-aligned
  },
  buttonText: {
    fontWeight: '700',
    fontSize: 16,
  },
});
